import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Link from '@ux/link';
import { updateQuery, useMobile, useTemporaryLogo } from '@ux/logo-hooks';
import goLogo from './goLogo.js';

/**
 * Renders shared GD logo.
 *
 * @param {Object} props Properties
 * @returns {React.ReactElement} shared logo
 * @public
 */
export default function GDLogo(props) {
  var isMobile = useMobile(props);
  var tempLogo = useTemporaryLogo(props);
  // render an alternate logo if the timeframe applies
  if (tempLogo) return tempLogo;
  var logo = /*#__PURE__*/React.createElement(React.Fragment, null, props.market !== 'en-US' && props.showCountryNameOnLogo && /*#__PURE__*/React.createElement("span", {
    className: "topnav-country"
  }, props.country), /*#__PURE__*/React.createElement("figure", {
    className: classnames('go-logo', isMobile ? 'mobile-logo' : 'desktop-logo', props.figClass),
    "aria-label": "GoDaddy"
  }, /*#__PURE__*/React.createElement("figcaption", {
    className: "sr-only"
  }, "GoDaddy"), isMobile ? goLogo.mobile : goLogo.desktop));
  return props.href ? /*#__PURE__*/React.createElement(Link, {
    className: props.className,
    urlArgs: props.urlArgs,
    "data-eid": props['data-eid'],
    onClick: props.onClick,
    href: updateQuery(props.href, props.urlArgs)
  }, logo) : logo;
}
GDLogo.defaultProps = {
  collapsedLogo: false,
  country: '',
  market: 'en-US',
  showCountryNameOnLogo: false,
  urlArgs: {}
};
GDLogo.propTypes = {
  /** CSS class name to apply to the outer element */
  'className': PropTypes.string,
  /** use the mobile logo at all breakpoints */
  'collapsedLogo': PropTypes.bool,
  /** Current country name. Required. */
  'country': PropTypes.string,
  /** Unique id used for Traffic 2 ie: 'your.product.godaddy.preformatted.eid_value.click' */
  'data-eid': PropTypes.string,
  /** href to pass to Link component */
  'href': PropTypes.string,
  /** Current market. */
  'market': PropTypes.string,
  /** Callback for a click on the logo link */
  'onClick': PropTypes.func,
  /** false in the US market and tablet and mobile, otherwise based on showCountryNameOnLogo in utility-bar */
  'showCountryNameOnLogo': PropTypes.bool,
  /** CSS class name to apply to wrapping `figure` element */
  'figClass': PropTypes.string,
  /** An object with specifications for a temporary alternate logo */
  'tempLogo': PropTypes.object,
  /** An object with arguments being passed to `Link` component to generate correct `href` */
  'urlArgs': PropTypes.object,
  /** An object with arguments being passed to `Link` component to generate correct `href` */
  'urls': PropTypes.shape({
    cdn: PropTypes.shape({
      href: PropTypes.string
    })
  })
};